import { Component, OnInit } from '@angular/core';
import { RecordsService } from '../services/records.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.css']
})
export class AdvancedSearchComponent implements OnInit {
  
  public index:number = 0;
  public years:Array<any> = [];
  public years2:Array<any> = [];
  public curryear:number = new Date().getFullYear();
  public paysedition: any;
  public langueSource: any;
  public langueCible: any;
  public themes: any;
  public subthemes: any;
  public themesel: any;
  public listnat: any;
  public shs: boolean = true;
  public lmg: boolean = false;

  

  constructor(public recordService: RecordsService, public router: Router, public translate: TranslateService) { 
    this.translate.onLangChange.subscribe(() => {
        this.getPaysEditions();
        this.getLangCible();
        this.getLangSource();
        this.getThemes();
        this.getNat();
    });
  }

  ngOnInit(): void {
    this.index=0;
    this.shs = this.recordService.shs;
    this.lmg = this.recordService.lmg;
    for(let i=this.curryear; i>=1600; i--)
    {
      this.years[this.index] = i;
      this.index++;
    }
    this.index=0;
    for(let i=this.curryear; i>=1600; i--)
    {
      this.years2[this.index] = i;
      this.index++;
    }
    this.getPaysEditions();
    this.getLangCible();
    this.getLangSource();
    this.getThemes();
    this.getNat();
  }
  
  onchangeDate(value:number) {
    this.years2 = [];
    this.index=0;
    for(let i=this.curryear; i>=value; i--)
    {
      this.years2[this.index] = i;
      this.index++;
    }
  }

  public getPaysEditions(){
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/paysedition/'+this.translate.currentLang)
      .subscribe(data => {
        this.paysedition = data;
      }, err =>{
        console.log(err);
      });
  }

  public getNat(){
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listnat/'+this.translate.currentLang)
      .subscribe(data => {
        this.listnat = data;
      }, err =>{
        console.log(err);
      });
  }
  public getLangSource(){
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listlanguesourcea/ar')
      .subscribe(data => {
        this.langueSource = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listlanguesourcea/fr')
      .subscribe(data => {
        this.langueSource = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  public getLangCible(){
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listlangueciblea/ar')
      .subscribe(data => {
        this.langueCible = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listlangueciblea/fr')
      .subscribe(data => {
        this.langueCible = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  public getThemes(){
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listthemes/ar')
      .subscribe(data => {
        this.themes = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listthemes/fr')
      .subscribe(data => {
        this.themes = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  public getSubtheme(val) {
    if(this.translate.currentLang=='ar') {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listsubthemes/' + val + '/ar')
      .subscribe(data => {
        this.subthemes = data;
      }, err =>{
        console.log(err);
      });
    } else {
      this.recordService.getFilters('http://trad.fondation.org.ma:8090/api/listsubthemes/' + val + '/fr')
      .subscribe(data => {
        this.subthemes = data;
      }, err =>{
        console.log(err);
      });
    }
  }

  onSearch(value: any) {
    if(value.titre) this.recordService.titre = value.titre; else this.recordService.titre=" ";
    if(value.titre_par) this.recordService.titre_par = value.titre_par; else this.recordService.titre_par=" ";
    if(value.auteur) this.recordService.auteur = value.auteur; else this.recordService.auteur=" ";
    if(value.desc) this.recordService.desc = value.desc; else this.recordService.desc=" ";
    if(value.paysedition) this.recordService.pays_org = value.paysedition; else this.recordService.pays_org=" ";
    if(value.mention_res) this.recordService.mention_res = value.mention_res; else this.recordService.mention_res=" ";
    if(value.first) this.recordService.first = value.first; else this.recordService.first="1600";
    if(value.end) this.recordService.end = value.end; else this.recordService.end = this.curryear.toString();
    if(value.langsource) this.recordService.langsource = value.langsource; else this.recordService.langsource=" ";
    if(value.langcible) this.recordService.langcible = value.langcible; else this.recordService.langcible=" ";
    if(value.theme) this.recordService.theme = value.theme; else this.recordService.theme=" ";
    if(value.themeg) this.recordService.themeg = value.themeg; else this.recordService.themeg=" ";
    if(value.sexe) this.recordService.sexe = value.sexe; else this.recordService.sexe=" ";
    if(value.nat) this.recordService.nat = value.nat; else this.recordService.nat=" ";


    //alert(this.recordService.titre+this.recordService.titre_par+this.recordService.auteur+this.recordService.desc+this.recordService.pays_org+this.recordService.mention_res+this.recordService.first+this.recordService.end);
    this.recordService.advanced = 'true';
    this.recordService.getRecordsByterm('', 'expression', 0);
    this.router.navigate(['/search']);
  }
  

  // changeShs(e: any) {
  //   this.shs = e.target.checked;
  //   this.recordService.shs = e.target.checked;
  //   this.recordService.getRecords(0);
  // }

  // changeLmg(e: any) {
  //   this.lmg = e.target.checked;
  //   this.recordService.lmg = e.target.checked;
  //   this.recordService.getRecords(0);
  // }

}
